define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var _ = require('underscore');

    return Marionette.ItemView.extend({
        template: '<span class="badge badge-important">{{#if number}} {{ number }} {{/if}}</span>',
        
        className: 'fa fa-phone js-btn-calls',

        initialize: function () {
            this.model = new Backbone.Model();
            this.listenTo(app.Models.Counters, 'change:missed_calls', this.setCount);
            this.setCount();
        },

        setCount: function() {
            this.model.set('number', +(app.Models.Counters.get('missed_calls') || 0));
            this.render();
        },

        onDestroy: function() {
            app.Models.Counters.off('change:missed_calls', this.setCount, this);
        }

    });
});